import { Api } from '@/api/Api'
import { ActionTree } from 'vuex'
import { RootState } from '../types'
import State, { IMaterialConfiguration, ISapConfiguratorValue } from './types'
import { Model } from '../model-viewer/types'

const api = new Api()

/** Coalesce concurrent / repeated catalog fetches (e.g. product finder + one modal per cart line). */
let fetchMaterialsInflight: Promise<void> | null = null

export const actions: ActionTree<State, RootState> = {
  fetchConfigurableMaterials({ commit, state }): Promise<void> {
    if (state.materialsCatalogLoaded) {
      return Promise.resolve()
    }
    if (fetchMaterialsInflight) {
      return fetchMaterialsInflight
    }
    fetchMaterialsInflight = (async () => {
      try {
        commit('resetRequest')
        const response = await api.fetch({
          url: '/ConfigureMaterial/materials',
        })
        const data: Model[] = response.List
        commit('materialsLoaded', data)
      } catch {
        commit('materialsError')
      } finally {
        fetchMaterialsInflight = null
      }
    })()
    return fetchMaterialsInflight
  },
  clearConfiguration({ commit }): any {
    commit('clearConfiguration')
  },
  getConfiguration({ commit, state }): any {
    const securityState = (this.state as any).security
    return api
      .fetchV2({
        url: '/ConfigureMaterial',
        user: securityState.currentUser,
        method: 'POST',
        obj: { Data: state.request },
      })
      .then((response) => {
        const data: IMaterialConfiguration = response
        commit('configurationLoaded', data)
      })
      .catch(() => {
        commit('materialsError')
      })
  },
  setValue({ commit, state }, value: ISapConfiguratorValue): any {
    const securityState = (this.state as any).security
    const request: any = state.request
    // remove existing value if any
    const existingValue = request.UserValues.find((s: any) => s.Characteristic === value.Characteristic)
    if (existingValue) {
      existingValue.Values = value.Values
    } else {
      request.UserValues.push(value)
    }
    return api
      .fetchV2({
        url: '/ConfigureMaterial',
        user: securityState.currentUser,
        method: 'POST',
        obj: { Data: state.request },
      })
      .then((response) => {
        const data: IMaterialConfiguration = response
        commit('configurationLoaded', data)
      })
      .catch(() => {
        commit('materialsError')
      })
  },
  resetRequest({ commit }): any {
    commit('resetRequest')
  },
}
